import { Navigate } from "react-router-dom";

//Analytics
import Analytics from "../pages/Analytics/Analytics";
//Cortex Chat
import CortexChat from "src/pages/CortexChat";
//Contacts
import UserList from "../pages/Users/ClientUsers/UserList";
import AddEditUser from "../pages/Users/ClientUsers/AddEditUser";
import Branding from "src/pages/Branding/branding";
import Clients from "src/pages/Clients/clients";
import TeamUsers from "../pages/Users/TeamUsers/TeamUsers";

//profile
import UserProfile from "../pages/Users/ClientUsers/UserProfile"
import CorporateInfo from "../pages/Branding/CorporateInfo";

//Authentication pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import ResetPassword from "../pages/Authentication/ResetPassword"

//utility
import PagesComingsoon from "../pages/Utility/PageComingsoon";
import PageMaintenance from "../pages/Utility/PageMaintenance";

import ViewProposal from "src/pages/Billing/Proposals/ViewProposal";
import Billing from "src/pages/Billing/Billing";
import ReportsPage from "src/pages/ReportsPage/ReportsPage";

//Email Report
import ListEmailReports from "../pages/EmailReport/ListEmailReports";
import DataOptions from "src/pages/DataOptions/DataOptions";

interface RouteProps {
  path: string;
  component: any;
  exact?: boolean;
}

const userRoutes: Array<RouteProps> = [
  //dashboard
  { path: "/analytics", component: <Analytics /> },
  { path: "/reports", component: <ReportsPage/>},
  { path: "/cortex-chat", component: <CortexChat/> },
  { path: "/user-list", component: <UserList/> },
  { path: "/branding", component: <Branding/> },
  { path: "/clients", component: <Clients/> },
  { path: "/view_proposal", component: <ViewProposal /> },
  { path: "/view_proposal/:proposal_id", component: <ViewProposal /> },
  { path: "/billing", component: <Billing /> },
  { path: "/data-options", component: <DataOptions/> },
  { path: "/team", component: <TeamUsers/> },
  { path: "/add-edit-user", component: <AddEditUser/> },

  //Profile
  { path: "/profile", component: <UserProfile/> },
  { path: "/corporate-info", component: <CorporateInfo/>},

  //Email reports
  {path: "/email-reports", component: <ListEmailReports /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/analytics" />,
  },
  { path: "*", component: <Navigate to="/analytics" /> },
];

const authRoutes: Array<RouteProps> = [
  //Authentication pages
  { path: "/login", component: <Login/> },
  { path: "/logout", component: <Logout/> },
  { path: "/register", component: <Register/> },
  { path: "/forgot-password", component: <ForgetPwd/> },
  { path: "/reset-password/:token", component: <ResetPassword/>},

  // //utility page
  { path: "/pages-comingsoon", component: <PagesComingsoon/> },
  { path: "/pages-maintenance", component: <PageMaintenance/> },
];

export { userRoutes, authRoutes };
